import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RouteNamesEnum } from '@citizen/routes/routes';
import { GridAuditUserService } from '@shared/services/audit-service/grid-audit-user.service';
import { GridTypeEnum, gridTableheadersMap } from '@shared/utils/mappers/grid-mapper';
import { GridPageActions, IGridPageModel } from '@types-custom/models/ui/grid-page-model';
import { IGridTableCellDispatcher } from '@types-custom/models/ui/grid-table-model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { Subject } from 'rxjs';
import { IAuditComponent, IAuditModel, IAuditGridModel, fileNameAuditDownloaded } from '@shared/models/audit.model';
import { Breadcrumb } from '@types-custom/models/ui/breadcrumb-model';
import { ExportExcelService } from '@citizen/services/data-grid-service/export-excel-service/export-excel.service';

@Component({
  selector: 'grid-audit-user',
  templateUrl: './grid-audit-user.component.html',
  styleUrls: ['./grid-audit-user.component.scss'],
})
export class GridAuditUserComponent implements OnInit {

  @Input() model: IAuditModel;
  @Output() handleValue = new EventEmitter<any>();

  breadcrumbs: Breadcrumb[];
  Icon = Icon;
  icon = Icon.manage_accounts_w;
  layerName = GridTypeEnum.ManageGridUserAudit;
  editColumnDispatcher = new Subject<IGridTableCellDispatcher>();
  isAllowDownload = true;

  gridPageProps: IGridPageModel = {
    headers: gridTableheadersMap([this.editColumnDispatcher])[this.layerName],
    dataSource: this.gridAuditUserService,
    isAllowDownloadExcel: this.isAllowDownload,
    isAllowDownloadPdf: false,
    dispatcher: this.editColumnDispatcher
  };

  constructor(
    private router: Router,
    public gridAuditUserService: GridAuditUserService,
    private exportExcelService: ExportExcelService,
  ) {
    this.gridAuditUserService.init();
    this.editColumnDispatcher.subscribe(this.handleClick.bind(this));
  }

  ngOnInit(): void {
    this.breadcrumbs = this.model.routes;
    if(this.breadcrumbs.length == 1) {
      this.breadcrumbs.push({
        label: this.model?.data?.userRealName,
        url: IAuditComponent.GRID_AUDIT_USER
      });
    }
  }

  public handleClick(columnAction: IGridTableCellDispatcher): void {
    const auditUser: IAuditGridModel = columnAction.row;
    // CONSUMIR EL SERVICIO PARA OBTENER LA DATA DE LA AUDITORIA SELECCIONADA
    this.gridAuditUserService
      .getDataSelected(this.model.code, auditUser.id,  auditUser.revId)
      .subscribe({
        next: (data: Array<any>) => {
          const modelAudit: IAuditModel = {
            code: this.model.code,
            renderAuditPanel: true,
            data: auditUser,
            dataAux: data,
            routes: this.model.routes
          };
          this.handleValue.emit(modelAudit);
        },
      });
  }

  navigateToVisor(): void {
    this.router.navigate([RouteNamesEnum.MapViewer]);
  }

  navigateToPrincipal(component: string): void {
    if(component == IAuditComponent.PRINCIPAL) {
      const modelAudit: IAuditModel = {
        code: this.model.code,
        renderGridUser: false,
        renderPrincipal: true
      };
      this.handleValue.emit(modelAudit);
    }
  }

  handleDownloadGridAction(fileType: GridPageActions): void {
    const fileProps = {
      url: this.gridAuditUserService.buildExcelUrl(this.model.code, this.model.data.id),
    };
    this.exportExcelService.downloadFile(
      fileProps.url,
      fileNameAuditDownloaded[this.layerName],
      fileType as unknown as string
    );
  }
}
